const initialState = {
    items: [],
    single: {},
    refresh: false,
    loading:false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GLOBALS_RESET':
            return initialState;


        case 'GLOBAL_FIELD_GET_ALL_LOADING':
            return {
                ...state,
                loading:true,
            };
        case 'GLOBAL_FIELD_GET_ALL_SUCCESS':
            return {
                ...state,
                items: action.payload,
                loading:false
            };
        case 'GLOBAL_FIELD_GET_ALL_FAILED':
            return {
                ...state,
                loading:false,
            };


        case 'GET_GLOBALS':
            return {
                ...state,
                items: action.payload.global,
                loading:false
            };

        case 'GLOBAL_FIELD_GET_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data
            };
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/global.js